// // src/components/common/SearchInput.tsx
// import { TextField } from '@mui/material';
// import { useState, useEffect } from 'react';

// const SearchInput = ({
//   onSearch,
//   delay = 500,
//   placeholder = "Search..."
// }) => {
//   const [value, setValue] = useState("");

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       onSearch(value);
//     }, delay);

//     return () => clearTimeout(handler); 
//   }, [value, delay]);

//   return (
//     <TextField
//       fullWidth
//       variant="outlined"
//       placeholder={placeholder}
//       size="small"
//       value={value}
//       onChange={(e) => setValue(e.target.value)}
//     />
//   );
// };

// export default SearchInput;


import React, { useState, useEffect } from "react";
import { Box, IconButton, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useDebounce } from "../../../shared/hooks/useDebounce";


const SearchBar = ({ onSearch, delay = 400, placeholder = "Search..." }) => {
  const [value, setValue] = useState("");

  // Use the reusable debounce hook
  const debouncedSearch = useDebounce(value, delay);

  useEffect(() => {
    onSearch(debouncedSearch);
  }, [debouncedSearch]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        borderRadius: "50px",
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        px: 2,
        py: 0.5,
      }}
    >
      <IconButton>
        <SearchIcon sx={{ opacity: 0.6, mr: 1 }} />
      </IconButton>

      <InputBase
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{ fontSize: "15px" }}
      />

      {value && (
        <IconButton size="small" onClick={() => setValue("")}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default SearchBar;
